import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('banks', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        show: (cntx, { id }) => {
            return new Promise((resolve, reject) => {
                axios.get(`banks/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        create: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('banks', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        update: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.put(`banks/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        remove: (cntx, id) => {
            return new Promise((resolve, reject) => {
                axios.delete(`banks/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        createBranch: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('branches', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        updateBranch: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.put(`branches/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        removeBranch: (cntx, id) => {
            return new Promise((resolve, reject) => {
                axios.delete(`branches/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}
